'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/react/react.js
// module id = 1
// module chunks = 0